import { Injectable } from '@angular/core';
import { JSONRPCService } from '@s8l/client-tree-lib';

import { serviceURL } from './service';

export interface BookingEvent {
  id?: number;
  name: string;
  description?: string;
  startTime?: Date;
  endTime?: Date;
  location?: string;
  capacity?: number;
  booked?: number;
}

export interface IdContainer {
  id: number;
}

export interface Booking {
  userUuid?: string;
  firstname: string;
  lastname: string;
  email: string;
}

export interface BookingRequest {
  booking: Booking;
  event: number;
}

@Injectable({
  providedIn: 'root'
})
export class BookingServerService extends JSONRPCService {
  public eventsList(): Promise<BookingEvent[]> {
    return this.message(serviceURL('BOOKING_SERVER', '/events'), 'list', {});
  }
  public eventsCreate(params: BookingEvent): Promise<BookingEvent> {
    return this.message(serviceURL('BOOKING_SERVER', '/events'), 'create', params);
  }

  public eventsDelete(params: IdContainer): Promise<BookingEvent> {
    return this.message(serviceURL('BOOKING_SERVER', '/events'), 'delete', params);
  }

  public eventsUpdate(params: BookingEvent): Promise<BookingEvent> {
    return this.message(serviceURL('BOOKING_SERVER', '/events'), 'update', params);
  }

  public bookingCreate(params: BookingRequest): Promise<BookingEvent> {
    return this.message(serviceURL('BOOKING_SERVER', '/events'), 'create', params);
  }

  public bookingList(params: IdContainer): Promise<Booking[]> {
    return this.message(serviceURL('BOOKING_SERVER', '/booking'), 'list', params);
  }

  public bookingBooked(): Promise<BookingEvent[]> {
    return this.message(serviceURL('BOOKING_SERVER', '/booking'), 'booked', {});
  }

  public bookingUnbook(params: IdContainer): Promise<BookingEvent> {
    return this.message(serviceURL('BOOKING_SERVER', '/booking'), 'unbook', params);
  }
}
